export default "__VITE_ASSET__TER2S1gP__"